import type { PortalContext } from "../contexts/MerchantContext";

type ResolvableScope = {
  merchantIds: string[];
  orgIds: string[];
};

export function isContextResolvable(
  context: PortalContext | undefined,
  scope: ResolvableScope
): boolean {
  if (!context) return false;
  return context.type === "org"
    ? scope.orgIds.includes(context.id)
    : scope.merchantIds.includes(context.id);
}

export function resolveDefaultContext(
  stored: PortalContext | undefined,
  scope: ResolvableScope
): PortalContext | undefined {
  if (isContextResolvable(stored, scope)) return stored;

  const [firstOrgId] = scope.orgIds;
  if (firstOrgId) return { type: "org", id: firstOrgId };

  const [firstMerchantId] = scope.merchantIds;
  if (firstMerchantId) return { type: "merchant", id: firstMerchantId };

  return undefined;
}
